import BaseService from './BaseService'
import entities from 'src/config/entities'

class NewsLetterService extends BaseService {
  constructor () {
    super({entity: entities.NEWSLETTER})
  }
}

export default new NewsLetterService()
